import React from 'react'
import { useTranslation } from '../../hooks/use-i18n'

export type TodayQuickPanel = 'photo' | 'fasting' | 'body' | null

interface Props {
  activePanel: TodayQuickPanel
  fastingActive?: boolean
  onTakePhoto: () => void
  onAddMeal: () => void
  onFasting: () => void
  onOutOfBody: () => void
}

const HowIEatTodayQuickActions: React.FC<Props> = ({
  activePanel,
  fastingActive,
  onTakePhoto,
  onAddMeal,
  onFasting,
  onOutOfBody,
}) => {
  const { t } = useTranslation()

  const actions: Array<{
    id: string
    label: string
    icon: string
    onPress: () => void
    active: boolean
    badge?: boolean
  }> = [
    { id: 'photo', label: t('howIEat.todayActions.takePhoto'), icon: '📷', onPress: onTakePhoto, active: activePanel === 'photo' },
    { id: 'meal', label: t('howIEat.todayActions.addMeal'), icon: '🍽️', onPress: onAddMeal, active: false },
    { id: 'fasting', label: t('howIEat.todayActions.fasting'), icon: '⏱️', onPress: onFasting, active: activePanel === 'fasting', badge: fastingActive },
    { id: 'body', label: t('howIEat.todayActions.outOfBody'), icon: '⚖️', onPress: onOutOfBody, active: activePanel === 'body' },
  ]

  return (
    <div className="grid grid-cols-2 gap-2 mb-4">
      {actions.map((action) => (
        <button
          key={action.id}
          type="button"
          onClick={action.onPress}
          className={`relative flex flex-col items-center justify-center px-2 py-3.5 rounded-xl border text-center transition-colors ${
            action.active
              ? 'bg-emerald-500/20 border-emerald-500/50 text-emerald-400'
              : 'bg-white/5 border-white/10 text-white hover:bg-white/10'
          }`}
        >
          <span className="text-xl leading-none">{action.icon}</span>
          {action.badge ? (
            <span className="absolute top-3 right-[calc(50%-18px)] w-2 h-2 rounded-full bg-amber-400" />
          ) : null}
          <span className="mt-2 text-xs font-bold leading-tight">{action.label}</span>
        </button>
      ))}
    </div>
  )
}

export default HowIEatTodayQuickActions
